module.exports = __webpack_public_path__ + "static/media/dashboard-icon-active (1).5b502101.svg";